import { IBetRecord } from '@/apis/bet-record';
import { TInferSchemaType, wsBalanceChangeSchema } from '@/constants/schemas';

export enum WebSocketCategoryEnum {
  /**
   * placeholder
   */
  UNKNOWN = 0,
  /**
   * message from websocket system
   */
  WEBSOCKET = 1,
  /**
   * message from Crash game
   */
  CRASH_GAME = 2,
  /**
   * message from Rush game
   */
  RUSH_GAME = 3,
  /**
   * message from payment system
   */
  PAYMENT = 4,
  /**
   * currently for betting record
   */
  RECORD = 5,
}

export enum WebSocketCommandsEnum {
  UNKNOWN_COMMAND = 0,

  LOGIN_REQUEST = 1,

  LOGIN_RESPONSE = 2,

  GAME_ENTER_REQUEST = 3,

  GAME_ENTER_RESPONSE = 4,

  GAME_QUIT_REQUEST = 5,

  GAME_QUIT_RESPONSE = 6,

  MOON_CRASH_STATUS_NOTIFY_COMMAND = 7,

  MOON_CRASH_CASH_OUT_EVENT_NOTIFY_COMMAND = 8,

  MOON_CRASH_BET_EVENT_NOTIFY_COMMAND = 9,

  USER_ACCOUNT_CHANGE_COMMAND = 10,

  RECONNECT = 11,

  CRASH_ONLINE_USER_COMMAND = 12,

  GLOBAL_BET_HISTORY_COMMAND = 13,

  USER_BET_HISTORY_COMMAND = 14,

  HIGH_ROLLER_HISTORY_COMMAND = 15,

  /**
   * 推送rush最新的游戏状态
   */
  RUSH_STATUS_NOTIFY_COMMAND = 16,

  LIVE_WINS_LATEST_COMMAND = 21,
  LUCKY_BET_HISTORY_COMMAND = 20,

  RUSH_BET_EVENT = 22,

  // command logout
}

export interface IWebSocketData {
  [WebSocketCategoryEnum.UNKNOWN]: any;
  [WebSocketCategoryEnum.WEBSOCKET]: any;
  [WebSocketCategoryEnum.CRASH_GAME]: any;
  [WebSocketCategoryEnum.RUSH_GAME]: any;
  [WebSocketCategoryEnum.PAYMENT]: {
    data: TInferSchemaType<typeof wsBalanceChangeSchema>;
  };
  [WebSocketCategoryEnum.RECORD]: {
    data: IBetRecord;
  };
}

export enum WsEvent {
  Subscribe = 'subscribe',
  Complete = 'complete',
  Unsubscribe = 'complete',
}

export enum WsQuery {
  AllHouseBetsSubscription = 'AllHouseBetsSubscription',
  Crash = 'Crash',
  LuckyPot = 'LuckyPot',
}

export interface WsRequest {
  id: string;
  type: WsEvent;
  payload: {
    query: WsQuery;
  };
}
